import _mapKeys from "lodash/mapKeys";
export function getConnectionName(modelName, options) {
  var connectionMap = options.connectionMap,
    defaultConnection = options.defaultConnection;
  var connection = defaultConnection;
  _mapKeys(connectionMap, function (models, connectionName) {
    if (models.indexOf(modelName) >= 0) {
      connection = connectionName;
    }
  });
  return connection;
}
export default getConnectionName;